import React from "react";
import "./../../style.scss";
import { withStyles, Table, Paper, withTheme } from "@material-ui/core";
import styles from "./styles";
import Header from "../components/Header";
import Content from "../components/Content";
import { getTrailerContent } from "../utils";
import { SpottedTrailerMarker } from "../../../Markers";
import { compose } from "recompose";

const SpottedTrailerPopupInfo = ({ classes, trailerData, showTrailerScac, theme }) => {
  return (
    <Paper className={`popupBGColor ${classes.mapPopupContainer} ${classes.spottedTrailerPopupContainer}`}>
      <Table className={classes.table} padding="none">
        <Header
          name={trailerData.customerName}
          address={trailerData.spottedAddress}
          id={trailerData.customerCode}
          Marker={SpottedTrailerMarker}
          themeColors={{
            backgroundColor: theme.unassignPickupFillColor,
            borderColor: theme.markerStokeColor
          }}
        />
        <Content data={getTrailerContent(trailerData, showTrailerScac)} />
      </Table>
    </Paper>
  );
};

export default compose(withStyles(styles), withTheme())(SpottedTrailerPopupInfo);
